import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { PhoneEnabled } from '@mui/icons-material';


export interface PhoneCallDialogProps {
    title: string;
    text: string;
    open: boolean;
    onClose: () => void;
}

const PhoneCallDialog = ({ title, text, open, onClose }: PhoneCallDialogProps) => (
    <Dialog onClose={onClose} open={open}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '320px'}}>
            <PhoneEnabled sx={{ fontSize: '96px', color: 'inherit' }} />
            <Typography>{text}</Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} variant='contained' fullWidth>Hangup</Button>
        </DialogActions>
    </Dialog>
)

export default PhoneCallDialog;